import { render, staticRenderFns } from "./addroast.vue?vue&type=template&id=d3052106&"
import script from "./addroast.vue?vue&type=script&lang=js&"
export * from "./addroast.vue?vue&type=script&lang=js&"
import style0 from "./addroast.vue?vue&type=style&index=0&id=d3052106&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports